import { gql } from '@apollo/client';
import React from 'react';
import type { SlackSearchResultContent_ContentFragment } from '../graphql/generated/graphqlTypes';
import SlackMessage from './slack/SlackMessage';

const CONTENT_FRAGMENT = gql`
  fragment SlackSearchResultContent_content on MentionContentSlack {
    previous {
      ...SlackMessage_message
    }
    message {
      ...SlackMessage_message
    }
    next {
      ...SlackMessage_message
    }
  }
  ${SlackMessage.fragments.message}
`;

interface SlackSearchResultContentProps {
  content: SlackSearchResultContent_ContentFragment;
}

const SlackSearchResultContent = ({
  content: { previous, message, next },
}: SlackSearchResultContentProps) => (
  <>
    {previous && <SlackMessage message={previous} />}
    {message && <SlackMessage message={message} />}
    {next && <SlackMessage message={next} />}
  </>
);

SlackSearchResultContent.fragments = {
  content: CONTENT_FRAGMENT,
};

export default SlackSearchResultContent;
